export default __webpack_public_path__ + "static/media/free7flare.f4e58814.svg";